<template>
  <div>
    <el-row>
      <el-col :span="24">
        <div class="grid-content">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>批次模块</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: 'batchListProgress' }">批次进度</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: 'batchStatistics', query:{id:process.batchId} }">批次统计</el-breadcrumb-item>
            <el-breadcrumb-item>工序详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20"
            class="grid-content">
      <el-col :span="12">
        <div>
          工序名称：
          <span>{{process.name}}</span>
        </div>
      </el-col>
      <el-col :span="5">
        <div>
          批次：
          <span>{{process.batchName}}</span>
        </div>
      </el-col>
      <el-col :span="6">

      </el-col>
    </el-row>
    <el-row :gutter="20"
            class="grid-content">
      <el-col :span="5">
        <div>
          总件数：<span>{{process.total}}</span>
        </div>
      </el-col>
      <el-col :span="5">
        <div>
          已完成：<span>{{process.percentNum}}</span>
        </div>
      </el-col>
      <el-col :span="5">
        <div>
          工作进度：<span>{{process.percent}}%</span>
        </div>
      </el-col>
      <el-col :span="5">
        <div>
          状态：<span :class="tableRowClassName">{{process.state}}</span>
        </div>
      </el-col>

    </el-row>
    <el-table :data="tableData"
              border
              class="grid-content"
              style="width: 95%;">
      <el-table-column prop="staffName"
                       label="姓名">
      </el-table-column>
      <el-table-column prop="tel"
                       label="电话">
      </el-table-column>
      <el-table-column prop="amount"
                       label="完成件数">
      </el-table-column>
      <el-table-column prop="percents"
                       label="完成比例">
      </el-table-column>

    </el-table>
    <!-- <el-pagination
      class="grid-content"
      background
      @current-change="handleCurrentChange"
      layout="total, prev, pager, next"
      :total="totalCount"
      :page-size="pageSize"
      :page-count="pageTotal" ></el-pagination> -->
  </div>
</template>
<script>
import { processSel } from "@/api/batch";
import { processSum } from "@/api/workRecord";
export default {
  data() {
    return {
      process: {},
      // totalCount: 0,
      // pageSize: 10,
      // pageNum: 1,
      // pageTotal: 0,
      tableData: []
    };
  },
  mounted() {
    this.process = this.$route.query;
    this.getProcessSel();
  },
  methods: {
    // handleCurrentChange(e) {
    //   this.pageNum = e;
    //   this.getProcessSum();
    // },
    tableRowClassName() {
      if (this.process.percent > 100) {
        return "Danger-row";
      } else if (this.process.percent < 100) {
        return "warning-row";
      } else if (this.process.percent == 100) {
        return "success-row";
      }
    },
    getProcessSel() {
      const params = {
        enterpriseId: localStorage.getItem("company_id"),
        batchId: this.process.batchId
      };
      processSel(params)
        .then(res => {
          res.gridData.forEach(element => {
            if (element.id == this.process.id) {
              element.percentNum = (
                (element.total * element.percent) /
                100
              ).toFixed(0);
              if (element.percent > 100) {
                element.state = "已超出";
              } else if (element.percent == 100) {
                element.state = "已完成";
              } else {
                element.state = "未完成";
              }
              this.process = element;
              this.getProcessSum();
            }
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    getProcessSum() {
      const params = {
        processId: this.process.id
      };
      processSum(params)
        .then(res => {
          const data = [];
          res.gridData.forEach(element => {
            element.percents = element.percent + "%";
            data.push(element);
          });
          this.tableData = data;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style>
.Danger-row {
  background: rgb(253, 107, 107);
}
.warning-row {
  background: rgb(247, 194, 97);
}

.success-row {
  background: rgb(79, 255, 79);
}
</style>
